export const TRANSFER_TEMPLATE_CONTAINER_TAG_NAME = 'transfer-template-container';
